import getENV from "../../../../util/getENV";
import useSmartContract from "../../useSmartContract";

export default function useGraveyard() {
    //console.log('>>> useGraveyard')
    const { modules: { graveyard: { contract } } } = getENV();
    const { contract: graveyard } = useSmartContract(contract);
    return { graveyard }

}